<div class="access-docs-container">
  <div class="header">
    <div class="left">
      <h2>API Access Documentation</h2>
    </div>
    <div class="right">
      <app-breadcrumb class="breadcrumb-container"></app-breadcrumb>
    </div>
  </div>

  <div class="docs-content">
    <h3>How to generate and use your API Key</h3>

    <ol class="steps">
      <li>
        Click the <strong>Generate Key</strong> button  
        <span class="note">(Header → Help icon → Developer Console → Top right button)</span>.  
        This will open the role-based access control popup.
      </li>
      <li>
        Select the required role permissions (add, edit, delete, read) and fill in other details like 
        <strong>usage limit</strong> and <strong>expiration date</strong>.
      </li>
      <li>
        Click <strong>Create Key</strong>. Once generated, the new API key will appear in your developer console dashboard.
      </li>
      <li>
        Copy the API key you want to use, and include it in your request headers as:
        <div class="code-snippet">
          Authorization: ApiKey <span class="key-example">xxxxxx</span>
        </div>
      </li>
      <li>
        Now you can securely authorize and integrate Certiplate API in your other applications.
      </li>
        <li>
            Here’s an example of how to call an API endpoint using your key:
            <div class="code-snippet multi-line">
                curl -X POST {{apiBaseURL}}/some-endpoint \<br>
                &nbsp;&nbsp;-H "Authorization: ApiKey xxxxxx" \<br>
                &nbsp;&nbsp;-H "Content-Type: application/json" \<br>
                &nbsp;&nbsp;-d '&#123; "param1": "value1", "param2": "value2" &#125;'
            </div>
        </li>


    </ol>

    <p class="tip">
      <i class="fa fa-info-circle"></i>
      Keep your API key safe. Regenerate if you suspect it’s compromised.
    </p>
  </div>
</div>
